// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ucrs-logo--small{max-height:2.8rem;max-width:18rem}.ucrs-logo--medium{max-height:3.4rem;max-width:22rem}@media (min-width:1024px){.ucrs-logo--large{max-height:4rem;max-width:26rem}}.ucrs-logo--extralarge{max-height:5rem;max-width:37rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
